import { Injectable, InjectionToken } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, timeout } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../../../AuthService';
@Injectable()
export class SecuredHttpInterceptor implements HttpInterceptor {
    authtoken:any;
    DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
    defaultTimeout: number = 30000;
    constructor(private keycloakservice:KeycloakService,private authService:AuthService){
        this.authService.getKeyCloackToken("");
    }
    /**
     * Intercepts the http request and add the bearer token of the currently logged user.
     * 
     * @param request http request
     * @param next http handler
     */
    
    intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
     if(this.keycloakservice.isLoggedIn()){
        this.authtoken = this.authService.getkeycloakAuthToken
            request = request.clone( {
                setHeaders: {
                    Authorization: 'Bearer ' + this.authtoken
                }
            } );
        }
        const timeouts = Number(request.headers.get('timeout')) || this.defaultTimeout;
        return next.handle(request).pipe(timeout(timeouts));
      }
}